import React, { ReactElement } from "react";
import { match, P } from "ts-pattern";
import { useRefinementList, UseRefinementListProps } from "react-instantsearch";
import RefinedListValues, {
  DescriptionForItem,
  TransformItems
} from "./RefinedListValues";
import { BarCheckboxProps } from "@silversea-ssc/ui-components-react";
import RefinedListWrapper from "./RefinementListWrapper";
import { DynamicTitleFunction } from "components/FindYourCruise/Components/RefinementListFilter/RefinedListDropdown";
import { RefinementListItem } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";
import { cruisesLabel } from "src/utils/cruise";

type RefinedListDropdownProps = {
  // title: string | ReactElement;
  title: string | ReactElement | DynamicTitleFunction;
  dataContentName?: string;
  operator: UseRefinementListProps["operator"];
  attribute: UseRefinementListProps["attribute"];
  limit: UseRefinementListProps["limit"];
  transformItems: TransformItems;
  backgroundColor?: BarCheckboxProps["variant"];
  descriptionForItem?: DescriptionForItem;
};

const countSelected = (items: RefinementListItem[]) =>
  items.filter((i) => i.isRefined).length;

const RefinedList: React.FC<RefinedListDropdownProps> = ({
  backgroundColor,
  title,
  dataContentName,
  operator,
  attribute,
  limit,
  transformItems,
  descriptionForItem
}) => {
  const { items, refine } = useRefinementList({
    attribute,
    operator,
    limit
  });

  const realTitle = match(title)
    .with(P.instanceOf(Function), (fn) => fn(countSelected(items)))
    .with(P.string, (t) => t)
    .otherwise((el) => el);

  if (items.length == 0) return null;

  return (
    <RefinedListWrapper dataContentName={dataContentName} title={realTitle}>
      <RefinedListValues
        refine={refine}
        items={items}
        backgroundColor={backgroundColor}
        descriptionForItem={descriptionForItem}
        transformItems={transformItems}
        counterLabel={cruisesLabel}
      />
    </RefinedListWrapper>
  );
};

export default RefinedList;
